import { Bold, Italic, Code, Link } from "lucide-react";

const RichTextToolbar = ({ editor }) => {
  if (!editor) return null;

  const btnClass = (isActive) =>
    [
      "p-1.5 rounded transition-colors",
      isActive
        ? "text-zinc-900 dark:text-zinc-100 bg-zinc-200 dark:bg-zinc-700"
        : "text-zinc-400 hover:text-zinc-700 dark:hover:text-zinc-200 hover:bg-zinc-100 dark:hover:bg-zinc-800",
    ].join(" ");

  return (
    <div className="flex items-center gap-0.5">
      <button
        onClick={() => editor.chain().focus().toggleBold().run()}
        className={btnClass(editor.isActive("bold"))}
        title="Bold"
        aria-label="Bold"
      >
        <Bold className="h-3.5 w-3.5" strokeWidth={2.5} />
      </button>
      <button
        onClick={() => editor.chain().focus().toggleItalic().run()}
        title="Italic"
        aria-label="Italic"
      >
        <Italic className="h-3.5 w-3.5" strokeWidth={2.5} />
      </button>
      <button
        onClick={() => editor.chain().focus().toggleCode().run()}
        className={btnClass(editor.isActive("code"))}
        title="Inline code"
        aria-label="Inline code"
      >
        <Code className="h-3.5 w-3.5" strokeWidth={2.5} />
      </button>
      <button
        onClick={() => {
          const url = window.prompt("Enter URL:");
          if (url) {
            editor.chain().focus().setLink({ href: url }).run();
          }
        }}
        className={btnClass(editor.isActive("link"))}
        title="Link"
        aria-label="Link"
      >
        <Link className="h-3.5 w-3.5" strokeWidth={2.5} />
      </button>
    </div>
  );
};

export default RichTextToolbar;
